<template>
  <div class="container">
    <div class="search" style="display:flex">
      <el-form ref="form" style="flex:1" :inline="true" :model="search" class="demo-form-inline">
        <el-form-item>
          <el-input v-model.trim="search.kname" @change="Search" placeholder="模糊搜索名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="search.schema" clearable  @change="Search" placeholder="终端appid">
            <el-option
              v-for="item in applist"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" size="small" @click="addfeedType">新建</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <el-table border v-bind:data="list">
      <!-- <el-table-column label="序号" type="index" width="50"></el-table-column> -->
      <el-table-column label="反馈类型名称">
        <template v-slot="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="app是否隐藏">
        <template v-slot="scope">
          <span>{{ scope.row.is_hide==1?'显示':'隐藏' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="app">
        <template v-slot="scope">
          <span>{{ appcodename[scope.row.schema] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300px">
        <template v-slot="scope">
          <el-button type="primary" size="small" @click="editfeedtype(scope.row)">修改</el-button>
          <el-button type="danger" size="small" @click="deleteDelivery(scope.row.code)">删除</el-button>
          <i style="font-weight: 700;margin:0 5px" class="el-icon-top sort" @click="feedtypeSort(scope.row,2)"></i>
          <i style="font-weight: 700;margin:0 5px" class="el-icon-bottom sort" @click="feedtypeSort(scope.row,1)"></i>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      v-model:currentPage="search.page"
      :page-size="search.limit"
      layout="total, prev, pager, next"
      :total="total">
    </el-pagination>

    <!-- 新增修改 -->
    <el-dialog :title="title+'反馈类型'" v-model="dialogFormVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="app是否隐藏" prop="is_hide" label-width="110px">
          <el-select v-model="form.is_hide" clearable placeholder="请选择">
            <el-option label="显示" :value="1"></el-option>
            <el-option label="隐藏" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="反馈类型名称" prop="name" label-width="110px">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="appid" prop="schema" label-width="110px">
          <el-select v-model="form.schema">
            <el-option
              v-for="item in applist"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" v-if="!edit" @click="Validate(addconfirm)">新增</el-button>
          <el-button type="primary" v-if="edit" @click="Validate(editconfirm)">修改</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: '',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      search: {
        page: 1,
        limit: 10,
        kname: '',
        schema: ''
      },
      list: [],
      total: 0,
      title: '',
      dialogFormVisible: false,
      edit: false,
      form: {
        code: '',
        is_hide: '',
        name: '',
        schema: '',
      },
      rules: {
        is_hide: [{ required: true, message: '请输入app是否隐藏', trigger: 'blur' }],
        name: [{ required: true, message: '请输入反馈类型名称', trigger: 'blur' }],
        schema: [{ required: true, message: '请输入appid', trigger: 'blur' }],
      },
      applist: [],
      appcodename: {}
    }
  },
  computed: {},
  watch: {},
  methods: {
    handleCurrentChange(val) {
      this.search.page = val
      this.Search()
    },
    Getappid() {
      this.api.ClientList({
        page: 1,
        limit: 100,
      }).then(res => {
        if (res.data.code == 200) {
          this.applist = res.data.data.data
          res.data.data.data.forEach(item => {
            this.appcodename[item.code] = item.name
          })
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    Search(){
      this.api.FeedTypeList(this.search).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.data
          this.total = res.data.data.page_info.total
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    addfeedType () {
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.form = {}
      this.edit = false
      this.title = '新增'
      this.dialogFormVisible = true
    },
    editfeedtype (item) {
      this.form = {}
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.edit = true
      this.title = '修改'
      this.dialogFormVisible = true
      this.api.FeedTypeDetail({code:item.code}).then(res => {
        if (res.data.code == 200) {
          this.form=res.data.data
          return
        }
        this.$message.error('获取详情失败' + res.data.msg)
      })
    },
    deleteDelivery(item) {
      this.$confirm('是否删除该反馈类型?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除请求
        this.api.FeedTypeDelete({code: item}).then(res => {
           if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.Search()
            return
          }
          this.$message.error('删除失败' + res.data.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除'
        });
      })
    },
    feedtypeSort (item,action) {
      this.api.FeedTypeOrder({
        code: item.code,
        action: action
      }).then(res => {
        if (res.data.code == 200) {
          this.$message.success('修改排序成功')
          this.Search()
          return
        }
        this.$message.error('修改排序失败' + res.data.msg)
      })
    },
    Validate: function (call) {
      this.$refs['form'].validate(res => {
        if (res && call) {
          call()
        }
      })
    },
    update() {
      this.api.FeedTypeUpdate(this.form).then(res => {
        if (res.data.code == 200) {
          this.$message.success(this.title +'成功')
          this.dialogFormVisible = false
          this.Search()
          return
        }
        this.$message.error(this.title +'失败' + res.data.msg)
      })
    },
    addconfirm() {
      this.update()
    },
    editconfirm() {
      this.update()
    },
  },
  filters: {},
  mounted () {
    this.Search()
  },
  created () {
    this.Getappid()
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
</style>
